import { motion } from 'framer-motion';
import { getButtonClasses, type CommonButtonProps } from '@/components/ui/BaseButton';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    CommonButtonProps {}

const Button: React.FC<ButtonProps> = ({
  isLoading,
  isSubmitting,
  disabled,
  children,
  className,
  ...props
}) => {
  const isDisabled = disabled || isLoading || isSubmitting;

  return (
    <button
      className={getButtonClasses({
        ...props,
        isLoading,
        isSubmitting,
        disabled,
        className,
      })}
      disabled={isDisabled}
      {...props}
    >
      {isLoading || isSubmitting ? (
        <motion.span
          className="h-5 w-5 border-4 border-white border-t-transparent rounded-full"
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 0.6, ease: 'linear' }}
        />
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
